














































































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import {storeApprovisionnementsTotaux, ApprovisionnementFilter} from '@/stores/modules/approvisionnement';

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudClientSearch from "@/components/Crud/Client/Search.vue";
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import InputLongueursApprovisionnement from "@/components/Input/LongueursVente.vue";
	import {DateFilterMode} from "@/shared/filter";

	@Component({
		components: {
			InputDateFilter,
			CrudClientSearch,
			InputBoisType,
			InputLongueursApprovisionnement,
			CrudTransporteurSearch,
		}
	})
	export default class CrudApprovisionnementFilterTotauxApprovisionnements extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeApprovisionnementsTotaux) private page!: number;
		@Stored(() => storeApprovisionnementsTotaux) private filters!: ApprovisionnementFilter;

		@WatchObjectProperties('filters', ApprovisionnementFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeApprovisionnementsTotaux.dispatch( 'getTotauxApprovisionnements', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();

			this.filters.totalParBoisType = true;
			this.filters.totalParLongueur = true;
			
			let firstDayYear = new Date(new Date().getFullYear(), 0, 1, 1);
			this.filters.totalDateDebut = firstDayYear.toISOString().slice(0, 10)
			this.filters.totalDateFin = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}

		get computedDateStartFormatted () : string {
        	return this.formatDate(this.filters.totalDateDebut)
      	}

		get computedDateEndFormatted () : string {
        	return this.formatDate(this.filters.totalDateFin)
      	}

		  formatDate (date) {
        		if (!date) return null

        	const [year, month, day] = date.split('-')
        	return `${day}/${month}/${year}`
      	}

		private get methodName(): string {
			return 'getTotauxApprovisionnements';
		}

		@Watch('order')
		@Watch('page')
		@Watch('direction')
		private refresh(): void {
			storeApprovisionnementsTotaux.dispatch(this.methodName, { filters: true });
		}

		private menu = false;
		private menuEnd = false;
	}
